<template>
  <el-row class="panel-group">
    <el-row :key="sort" v-for="(o, sort) in orgs">
      <el-col class="card-panel-col" :span="8" v-for="(item, index) in o.deptinfo" :key="index"
        :offset="index > 0 ? 2 : 0">
        <el-card :body-style="{ padding: '0px' }">
          <img src="@/assets/logo.png" class="image">
          <div style="padding: 14px;">
            <span>{{item.deptname}}</span>
            <div class="bottom clearfix">
              <el-button type="danger">{{item.deptid}}</el-button>
              <el-button type="text" class="button">进入</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

  </el-row>


</template>

<script>
  export default {
    data() {
      return {
        currentDate: new Date(),
        orgs: [{
          orgid: '001',
          orgname: "徐州中心医院",
          deptinfo: [{
            deptid: "001_001",
            deptname: '耗材库',
            deptcode: '001',
            sort: 1
          }, {
            deptid: "001_002",
            deptname: '手术室',
            deptcode: '002',
            sort: 2
          }]


        }]
      };

    },
    props: {
      // orgInfo:{
      //     type:Array,
      //     default:[]
      // }

    },
    methods: {


    },
    created: {

    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .panel-group {

    // padding-top: 18px;
    .card-panel-col {
      margin-bottom: 32px;
    }

    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);

      &:hover {
        .card-panel-icon-wrapper {
          color: #fff;
        }

        .icon-people {
          background: #40c9c6;
        }

        .icon-message {
          background: #36a3f7;
        }

        .icon-money {
          background: #f4516c;
        }

        .icon-shoppingCard {
          background: #34bfa3
        }
      }

      .icon-people {
        color: #40c9c6;
      }

      .icon-message {
        color: #36a3f7;
      }

      .icon-money {
        color: #f4516c;
      }

      .icon-shoppingCard {
        color: #34bfa3
      }

      .card-panel-icon-wrapper {
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }

      .card-panel-icon {
        float: left;
        font-size: 48px;
      }

      .card-panel-description {
        float: right;
        font-weight: bold;
        margin: 26px;
        margin-left: 0px;

        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          margin-bottom: 12px;
        }

        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }
</style>